import { useSelector } from "react-redux";
import FounderList from "../component/FounderList";
import AccessDenied from "../component/AccessDenied";
import { isTaskAllowed } from "../utils/isTaskAllowed";

const Founders = () => {
    const { admin } = useSelector((state) => state.auth);

    if(admin?.email !== "admin@thriftyx.com" &&
        !isTaskAllowed("Founders", admin?.assignedWork)) return (<AccessDenied />)

    return ( <FounderList /> )
}
export default Founders;